import React, { useState } from 'react'
import { Alert } from 'react-bootstrap'

import Section from '../../Section/Section'
import Table from '../../Table'

import { Api, Endpoint } from '../../../api/index'

import { Cookies } from 'react-cookie'
import { toast } from 'react-toastify'

import LoadingSpinner from '../../LoadingSpinner'
import AdminStyle from '../../../Views/Admin/Admin.module.scss'
import Modal from '../../Modal'

import DeleteUser from '../../Forms/DeleteUser'
import ClientsSubscribe from './ClientsSubscribe/Main'

import { useHistory } from 'react-router-dom'

import EmbedMenuOptions from '../../RestaurantForm/EmbedMenuOptions'
import styles from './LicensesSubscriptionStatus.module.scss'

const cookies = new Cookies()

const TableActionButton = ({ children, ...props }) => (
	<button type="button" className={styles.tableActionBtn} {...props}>
		{children}
	</button>
)

export default function LicensesSubscriptionStatus({
	Auth,
	subscribedClients = [],
	unSubscribedClients = [],
	paymentMethods,
	loadClientsSubscriptionsStatus,
	productPrices,
	productPricesError,
	updatePlans,
}) {
	const history = useHistory()
	const plansAvailable = Boolean(productPrices?.monthly_product && productPrices?.yearly_product)

	const [loadingUserShapeShift, setLoadingUserShapeShift] = useState(-1)

	const [modal, setModal] = useState({
		visible: false,
		Component: null,
		title: '',
		closeModal: () => setModal({ ...modal, visible: false }),
	})

	const subscribeForAllClients = async () => {
		setModal({
			...modal,
			visible: true,
			title: `Subscribe for all clients (${unSubscribedClients?.length})`,
			Component: (
				<ClientsSubscribe
					paymentMethods={paymentMethods}
					productPrices={productPrices}
					unSubscribedClients={unSubscribedClients?.map((client) => client?._id)}
					loadClientsSubscriptionsStatus={loadClientsSubscriptionsStatus}
					updatePlans={updatePlans}
					closeModal={() => setModal({ ...modal, visible: false })}
				/>
			),
		})
	}

	const subscribeForMultipleUsers = async (users = {}) => {
		users = Object?.keys(users)
		setModal({
			...modal,
			visible: true,
			title: `Subscribe for ${users?.length} ${users?.length > 1 ? 'licenses' : 'license'}`,
			Component: (
				<ClientsSubscribe
					paymentMethods={paymentMethods}
					productPrices={productPrices}
					unSubscribedClients={users}
					loadClientsSubscriptionsStatus={loadClientsSubscriptionsStatus}
					updatePlans={updatePlans}
					closeModal={() => setModal({ ...modal, visible: false })}
				/>
			),
		})
	}

	const shapeshift = async (user) => {
		if (!user?.state) {
			toast('This account has not been verified.')
			return
		}
		setLoadingUserShapeShift(user?._id)

		const data = {
			_id: user._id,
			refreshToken: cookies.get('refreshToken'),
			email: user.email,
		}

		const response = await Auth.SHAPE_SHIFT(data, Endpoint.DMA.clients.shapeshift)
		if (response?.statusCode !== 200) {
			toast(response?.message)
			setLoadingUserShapeShift(-1)
			return
		}

		window.location.href = '/'
		setLoadingUserShapeShift(-1)
	}

	const showDeleteClientModal = (user) => {
		setModal({
			...modal,
			title: 'Remove license',
			visible: true,
			Component: (
				<DeleteUser
					{...modal}
					requires_password
					warning_message="Are you sure you want to remove this license?"
					user={user}
					submit={async (user, password) => {
						const response = await Api.call(Endpoint.DMA.clients.delete(user?._id), { data: { password } })
						if (response?.statusCode === 200) {
							loadClientsSubscriptionsStatus?.()
						}
						return response
					}}
				/>
			),
		})
	}

	const viewMore = function (user) {
		history.push(`/dma/client?id=${user?._id}`)
	}

	const showEmbedModal = (restaurant_id) => {
		setModal({
			...modal,
			visible: true,
			title: 'Embed Menu',
			Component: <EmbedMenuOptions {...modal} restaurantId={restaurant_id} />,
		})
	}

	const resendInvite = async (user) => {
		const response = await Api.call(Endpoint.DMA.clients.resendInvitation, {
			data: { client_id: user?._id },
		})
		if (response?.statusCode === 200) {
			toast('Invitation resent successfully')
			typeof loadClientsSubscriptionsStatus === 'function' && loadClientsSubscriptionsStatus()
			return
		}
		toast(response?.message || 'Failed to resend invitation')
	}

	const inviteStatusLabel = (row) => {
		if (row?.inviteStatus === 'awaiting_claim') {
			return 'Awaiting vendor claim'
		}
		return 'Active'
	}

	const inviteStatusColumn = {
		field: 'Status',
		render: ({ row }) => <span>{inviteStatusLabel(row)}</span>,
	}

	const resendInviteColumn = {
		field: 'Invite',
		render: ({ row }) =>
			row?.inviteStatus === 'awaiting_claim' ? (
				<TableActionButton onClick={() => resendInvite(row)}>Resend invite</TableActionButton>
			) : (
				<span>-</span>
			),
	}

	const columns = {
		subscribedClients: [
			{
				field: 'Email',
				access: 'email',
			},
			inviteStatusColumn,
			{
				field: 'Full Name',
				render: ({ row }) => (
					<span>
						{row?.firstName} {row?.lastName}
					</span>
				),
			},
			{
				field: 'Username',
				access: 'username',
			},
			resendInviteColumn,
			{
				field: 'Actions',
				render: ({ row }) => (
					<i
						onClick={() => showDeleteClientModal(row)}
						className={`${AdminStyle.deleteIcon} far fa-trash-alt`}
					></i>
				),
			},
			{
				field: 'View More',
				render: ({ row }) => (
					<div>
						<TableActionButton onClick={async () => viewMore(row)}>View More</TableActionButton>
					</div>
				),
			},
			{
				field: 'Copy Embed Code',
				render: ({ row }) => (
					<div>
						<TableActionButton onClick={() => showEmbedModal(row?.restaurants?.[0])}>
							Copy Embed Menu
						</TableActionButton>
					</div>
				),
			},
			{
				field: 'Login as',
				render: ({ row }) => (
					<TableActionButton
						disabled={loadingUserShapeShift !== -1}
						onClick={async () => await shapeshift(row)}
					>
						{loadingUserShapeShift?.toString() === row?._id?.toString() ? (
							<LoadingSpinner size="sm" />
						) : (
							'Login'
						)}
					</TableActionButton>
				),
			},
		],
		unSubscribedClients: [
			{
				field: 'Email',
				access: 'email',
			},
			inviteStatusColumn,
			{
				field: 'Full Name',
				render: ({ row }) => (
					<span>
						{row?.firstName} {row?.lastName}
					</span>
				),
			},
			{
				field: 'Username',
				access: 'username',
			},
			resendInviteColumn,
			{
				field: 'Actions',
				render: ({ row }) => (
					<i
						onClick={() => showDeleteClientModal(row)}
						className={`${AdminStyle.deleteIcon} far fa-trash-alt`}
					></i>
				),
			},
			{
				field: 'Subscribe',
				render: ({ row }) => (
					<div>
						<TableActionButton
							disabled={!plansAvailable}
							onClick={async () => subscribeForMultipleUsers({ [row?._id]: true })}
						>
							Subscribe
						</TableActionButton>
					</div>
				),
			},
			{
				field: 'View More',
				render: ({ row }) => (
					<div>
						<TableActionButton onClick={async () => viewMore(row)}>View More</TableActionButton>
					</div>
				),
			},
			{
				field: 'Copy Embed Code',
				render: ({ row }) => (
					<div>
						<TableActionButton onClick={() => showEmbedModal(row?.restaurants?.[0])}>
							Copy Embed Menu
						</TableActionButton>
					</div>
				),
			},
			{
				field: 'Login as',
				render: ({ row }) => (
					<TableActionButton
						disabled={loadingUserShapeShift !== -1}
						onClick={async () => await shapeshift(row)}
					>
						{loadingUserShapeShift?.toString() === row?._id?.toString() ? (
							<LoadingSpinner size="sm" />
						) : (
							'Login'
						)}
					</TableActionButton>
				),
			},
		],
	}

	return (
		<div>
			<Modal {...modal} />
			<Section title={`Subscribed licenses (${subscribedClients?.length})`}>
				<Table columns={columns?.subscribedClients} rows={subscribedClients} enableLocalPagination />
			</Section>
			<Section
				title={`Unsubscribed licenses (${unSubscribedClients?.length})`}
				action={
					plansAvailable && unSubscribedClients?.length > 0
						? { name: 'Subscribe for all', funk: subscribeForAllClients }
						: null
				}
			>
				{!plansAvailable && unSubscribedClients?.length > 0 && (
					<Alert variant="warning">
						Subscriptions are unavailable: {productPricesError || 'no subscription plans are configured.'}
					</Alert>
				)}
				<Table
					columns={columns?.unSubscribedClients}
					onSelectRowsRenderView={(checked, setChecked) => (
						<TableActionButton
							disabled={!plansAvailable}
							style={{ marginRight: '5px' }}
							onClick={() => {
								subscribeForMultipleUsers(checked)
								setChecked({})
							}}
						>
							Subscribe
						</TableActionButton>
					)}
					rows={unSubscribedClients}
					enableLocalPagination
					enableSelectMultiple
					onSelectRowsDisableDelete
				/>
			</Section>
		</div>
	)
}
